<app-modal #modalConfirmDialog [modalConfig]="modalConfigConfirm" [modalOptions]="{size:'lg'}">
  <div class="text-left mb-n8">
    <p>{{ renderConfirmationText() }}</p>
    <p class="mb-2">Cakupan:</p>
    <ul>
      <ng-container *ngFor="let item of selectedRegion">
        <li>
          <span>{{ item.name }}</span>
        </li>
      </ng-container>
    </ul>

    <div class="my-2" *ngIf="hasMitraList()">
      <app-note-view [color]="'warning'"  [extraContent]="true" [icon]="STRING_CONSTANTS.ICON.IC_DANGER_EXPIRED">
        <div style="color: #85774F;">
          <p class="mb-2">Terdapat kelurahan yang sudah menjadi cakupan Retailer/Mitra Maxxi Tani:</p>
          <ul class="ps-6">
            <li *ngFor="let mitra of (macMitraList$|async)">
              <span>{{ mitra.name }}</span>
              <span class="ms-2">- {{ renderMitraList(mitra.retailer) }}</span>
            </li>
          </ul>
        </div>
      </app-note-view>
    </div>

  </div>
</app-modal>

<app-modal #modalResponseDialog [modalConfig]="getModalResponseConfig()">
  <div class="d-flex flex-column justify-content-center align-items-center mb-n8">

    <ng-container *ngIf="loadingPost | async; else responseMessageTpl">
      <div class="mt-8">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>

    <ng-template #responseMessageTpl>
      <div class="mt-8 text-center">
        <span [inlineSVG]="(registerHasError|async) ? STRING_CONSTANTS.ICON.IC_DANGER : STRING_CONSTANTS.ICON.SUCCESS_ALERT"></span>
      </div>

      <div class="my-4 text-center">
        <span>{{ responsePost.value }}</span>
      </div>
    </ng-template>

<!--    <div class="w-100 my-5 py-5 d-flex flex-nowrap align-items-center">-->
<!--      <button-->
<!--        type="button"-->
<!--        color="primary"-->
<!--        class="btn btn-outline btn-outline&#45;&#45;secondary text-primary w-100 me-lg-3"-->
<!--        mat-button-->
<!--      >-->
<!--        {{ modalConfigResponse.closeButtonLabel }}-->
<!--      </button>-->
<!--      <button-->
<!--        type="button"-->
<!--        mat-raised-button-->
<!--        color="primary"-->
<!--        class="btn w-100 btn-primary"-->
<!--      >-->
<!--        {{ modalConfigResponse.dismissButtonLabel }}-->
<!--      </button>-->
<!--    </div>-->

  </div>
</app-modal>
